import { PageName } from "@tm/insurance/analytics";
import { ErrorScreenProps } from "../ui-container/ErrorScreen";
import { ErrorScreen } from "../ui-container/ErrorScreen";

export function withError(
  component: JSX.Element,
  error: ErrorScreenProps["error"],
  pageName: PageName,
  statusCode?: string,
  device?: ErrorScreenProps["device"]
) {
  return error ? (
    <ErrorScreen
      error={error}
      pageName={pageName}
      trackError
      statusCode={statusCode}
      device={device}
    />
  ) : (
    component
  );
}
